$(function() {

    /* globals $ */

    'use strict';

    $(document).on('change', 'select.assign-user', function () {

        $.ajax({
            url: '/lead_lists/' + $(this).data('lead-list-id') + '/assign',
            type: 'PATCH',
            dataType: 'json',
            data: {
                value: $(this).val()
            }
        });

    });

});